// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1jF_O","head":"ProcedureTableInfo_head__3oNz3"};